import { query, queryProvider, serviceQueries } from '@estee/elc-service-bus';

import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';

export class ServiceBusController {
    @queryProvider(serviceQueries.IS_LOYALTY_MEMBER)
    public isLoyaltyMember = async (): Promise<boolean> => {
        const { hasLoyalty = false } = (await query(serviceQueries.BASIC_USER_DETAILS)) || {};

        if (hasLoyalty) {
            await new LoadLoyaltyInfoUseCase().execute();
        }

        return hasLoyalty;
    };
}
